import styled from '@emotion/styled';
import { Alert } from '@ui-components/neo.tax';

export const StyledAlert = styled(Alert)({
  paddingLeft: '0',
  paddingBottom: '0',
});
